import { TypePolicies } from '@apollo/client';

import { handwrittenTypePolicies } from './handwrittenTypePolicies';
import { mergeTypePolicies } from './mergeTypePolicies';
import { typePolicies as generatedTypePolicies } from './typePolicies.generated';

export const mergedTypePolicies: TypePolicies = mergeTypePolicies(
  generatedTypePolicies,
  handwrittenTypePolicies
);
